// import React, { useEffect, useState } from "react";
// import {
//   Layout,
//   Card,
//   Form,
//   Input,
//   Upload,
//   Button,
//   Select,
//   message,
//   Image,
//   Typography
// } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import axios from "axios";
// import { BASE_URL } from "../../Config/index";
// import Sidebar from "../../Components/Sidebar";
// import SuccessPopup from "../../Components/popup/SuccessPopup";
// import ErrorPopup from "../../Components/popup/ErrorPopup";
// import { MenuOutlined } from "@ant-design/icons";

// const { Header, Content } = Layout;
// const { Option } = Select;
// const { Text: AntText } = Typography;

// const MakeVariation = () => {
//   const [form] = Form.useForm();

//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [successMessage, setSuccessMessage] = useState("");

//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);

//   useEffect(() => {
//     const checkScreen = () => setIsMobile(window.innerWidth <= 768);
//     checkScreen();
//     window.addEventListener("resize", checkScreen);
//     return () => window.removeEventListener("resize", checkScreen);
//   }, []);

//   const handleSubmit = async (values) => {
//     setLoading(true);

//     const formData = new FormData();
//     formData.append("variationName", values.variationName);
//     formData.append("sanskrit", values.sanskrit);
//     formData.append("exampleAsana", values.exampleAsana);
//     formData.append("english", values.english);
//     formData.append("variationType", values.variationType);
//     formData.append("asanaType", values.asanaType);

//     if (selectedImage) {
//       formData.append("variationImage", selectedImage);
//     }

//     try {
//       const res = await axios.post(`${BASE_URL}/makevariations`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (res.data.alreadyExists) {
//         setSuccessMessage("Variation already exists");
//       } else {
//         setSuccessMessage("Variation uploaded successfully!");
//       }

//       setSuccessPopup(true);

//       setSuccessPopup(true);

//       if (res.data.success) {
//         message.success("Variation created successfully!");

//         form.resetFields();
//         setImagePreview(null);
//         setSelectedImage(null);
//       } else {
//         message.error(res.data.message || "Failed to create variation");
//       }
//     } catch (error) {
//       console.error(error);
//       setErrorPopup(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Layout style={{ minHeight: "100vh" }}>
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}

//         collapsedWidth="0"
//         role="admin"
//       />

//       <Layout
//         className="main-layout"
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 40 : 210,
//           transition: "0.3s",
//           padding: isMobile ? 10 : 20,
//         }}
//       >

//         <Header className="MainHeader">

//           {isMobile && (
//             <Button
//               type="text"
//               icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }}
//             />
//           )}

//           <div style={{ flex: 1 }}>
//             <AntText
//               style={{
//                 fontSize: 20,
//                 fontWeight: "bold"
//               }}
//             >
//               Create Make Variation
//             </AntText>
//           </div>

//         </Header>
//         <Content style={{ padding: 20 }}>
//           <Card
//             title="Create New Variation"
//             bordered={false}
//             style={{ maxWidth: 700, margin: "0 auto" }}
//           >
//             <Form
//               form={form}
//               layout="vertical"
//               onFinish={handleSubmit}
//               autoComplete="off"
//             >
//               {/* Variation Name */}
//               <Form.Item
//                 label="Variation Name"
//                 name="variationName"
//                 rules={[
//                   { required: true, message: "Variation name is required" },
//                 ]}
//               >
//                 <Input placeholder="Adho Mukha" />
//               </Form.Item>

//               <Form.Item
//                 label="Asana Type"
//                 name="asanaType"
//                 rules={[{ required: true, message: "Asana type is required" }]}
//               >
//                 <Input placeholder="Asana type" />
//               </Form.Item>

//               <Form.Item
//                 label="Sanskrit Name"
//                 name="sanskrit"
//                 rules={[
//                   { required: true, message: "Sanskrit name is required" },
//                 ]}
//               >
//                 <Input placeholder="Adho Mukha Shvanasana" />
//               </Form.Item>

//               <Form.Item
//                 label="Example Asana"
//                 name="exampleAsana"
//                 rules={[
//                   { required: true, message: "Example asana is required" },
//                 ]}
//               >
//                 <Input placeholder="Adho Mukha Shvanasana example" />
//               </Form.Item>

//               <Form.Item
//                 label="Variation Type"
//                 name="variationType"
//                 rules={[
//                   { required: true, message: "Please select variation type" },
//                 ]}
//               >
//                 <Select placeholder="Select variation type">
//                   <Option value="Hand variations">Hand variations</Option>
//                   <Option value="variations on legs">Variations on legs</Option>
//                   <Option value="other variations">Other variations</Option>
//                 </Select>
//               </Form.Item>

//               <Form.Item
//                 label="English Description"
//                 name="english"
//                 rules={[
//                   { required: true, message: "English description required" },
//                 ]}
//               >
//                 <Input.TextArea rows={3} placeholder="Description..." />
//               </Form.Item>

//               {/* Image Upload */}
//               <Form.Item label="Upload Variation Image">
//                 <Upload
//                   beforeUpload={(file) => {
//                     setSelectedImage(file);

//                     const reader = new FileReader();
//                     reader.onload = (e) => setImagePreview(e.target.result);
//                     reader.readAsDataURL(file);

//                     return false;
//                   }}
//                   maxCount={1}
//                 >
//                   <Button icon={<UploadOutlined />}>Select Image</Button>
//                 </Upload>

//                 {imagePreview && (
//                   <Image
//                     src={imagePreview}
//                     width={200}
//                     style={{ marginTop: 15, borderRadius: 10 }}
//                   />
//                 )}
//               </Form.Item>

//               <Form.Item>
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   loading={loading}
//                   disabled={loading}
//                 >
//                   {loading ? "Creating..." : "Create Variation"}
//                 </Button>
//               </Form.Item>

//               <SuccessPopup
//                 open={successPopup}
//                 onClose={() => setSuccessPopup(false)}
//                 message={successMessage}
//               />

//               <ErrorPopup
//                 open={errorPopup}
//                 onClose={() => setErrorPopup(false)}
//                 message="Upload failed. Try again."
//               />
//             </Form>
//           </Card>
//         </Content>
//       </Layout>
//     </Layout>
//   );
// };

// export default MakeVariation;
// import React, { useEffect, useState } from "react";
// import {
//   Layout,
//   Card,
//   Form,
//   Input,
//   Upload,
//   Button,
//   Select,
//   message,
//   Image,
//   Typography,
//   Divider,
//   Space,
// } from "antd";
// import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
// import axios from "axios";
// import { BASE_URL } from "../../Config/index";
// import Sidebar from "../../Components/Sidebar";
// import SuccessPopup from "../../Components/popup/SuccessPopup";
// import ErrorPopup from "../../Components/popup/ErrorPopup";
// import { MenuOutlined } from "@ant-design/icons";

// const { Header, Content } = Layout;
// const { Option } = Select;
// const { Text: AntText } = Typography;

// const MakeVariation = () => {
//   const [form] = Form.useForm();

//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);

//   // Level 1: Categories (variationType) loaded from DB
//   const [categories, setCategories] = useState([]);
//   const [newCategoryInput, setNewCategoryInput] = useState("");

//   // Level 2: Poses (asanaType) filtered by selected category
//   const [allData, setAllData] = useState([]);
//   const [filteredPoses, setFilteredPoses] = useState([]);
//   const [newPoseInput, setNewPoseInput] = useState("");

//   useEffect(() => {
//     const checkScreen = () => setIsMobile(window.innerWidth <= 768);
//     checkScreen();
//     window.addEventListener("resize", checkScreen);
//     return () => window.removeEventListener("resize", checkScreen);
//   }, []);

//   useEffect(() => {
//     fetchAllData();
//   }, []);

//   const fetchAllData = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/makevariations/names`);
//       const data = res.data.data || [];
//       setAllData(data);

//       // Extract unique categories (variationType values)
//       const cats = [];
//       data.forEach((item) => {
//         const type = item.variationType?.[0];
//         if (type && !cats.includes(type)) cats.push(type);
//       });
//       setCategories(cats);
//     } catch (err) {
//       console.error("Failed to load data", err);
//     }
//   };

//   // When category selected → filter poses belonging to it
//   const handleCategoryChange = (selectedCategory) => {
//     form.setFieldsValue({ asanaType: undefined });
//     setFilteredPoses([]);

//     if (!selectedCategory) return;

//     const poses = [];
//     allData.forEach((item) => {
//       const type = item.variationType?.[0];
//       if (
//         type === selectedCategory &&
//         item.asanaType &&
//         !poses.includes(item.asanaType)
//       ) {
//         poses.push(item.asanaType);
//       }
//     });
//     setFilteredPoses(poses);
//   };

//   // When pose selected → auto-fill variationName
//   const handlePoseChange = (selectedPose) => {
//     if (selectedPose) {
//       form.setFieldsValue({ variationName: selectedPose });
//     }
//   };

//   // Add new category inline
//   const handleAddCategory = () => {
//     const trimmed = newCategoryInput.trim();
//     if (!trimmed) return;
//     if (categories.includes(trimmed)) {
//       message.warning("Category already exists — select it from the list");
//       setNewCategoryInput("");
//       return;
//     }
//     setCategories((prev) => [...prev, trimmed]);
//     form.setFieldsValue({ variationType: trimmed, asanaType: undefined });
//     setFilteredPoses([]);
//     setNewCategoryInput("");
//     message.success(`New category "${trimmed}" added and selected`);
//   };

//   // Add new pose inline
//   const handleAddPose = () => {
//     const trimmed = newPoseInput.trim();
//     if (!trimmed) return;
//     if (filteredPoses.includes(trimmed)) {
//       message.warning("Pose already exists — select it from the list");
//       setNewPoseInput("");
//       return;
//     }
//     setFilteredPoses((prev) => [...prev, trimmed]);
//     form.setFieldsValue({ asanaType: trimmed, variationName: trimmed });
//     setNewPoseInput("");
//     message.success(`New pose "${trimmed}" added and selected`);
//   };

//   const handleSubmit = async (values) => {
//     setLoading(true);

//     const formData = new FormData();
//     formData.append("variationName", values.variationName);
//     formData.append("sanskrit", values.sanskrit);
//     formData.append("exampleAsana", values.exampleAsana);
//     formData.append("english", values.english);
//     formData.append("variationType", values.variationType);
//     formData.append("asanaType", values.asanaType);

//     if (selectedImage) {
//       formData.append("variationImage", selectedImage);
//     }

//     try {
//       const res = await axios.post(`${BASE_URL}/makevariations`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (res.data.alreadyExists) {
//         setSuccessMessage("Variation already exists");
//       } else {
//         setSuccessMessage("Variation uploaded successfully!");
//       }

//       setSuccessPopup(true);

//       if (res.data.success) {
//         message.success("Variation created successfully!");
//         form.resetFields();
//         setImagePreview(null);
//         setSelectedImage(null);
//         setFilteredPoses([]);
//         fetchAllData();
//       } else {
//         message.error(res.data.message || "Failed to create variation");
//       }
//     } catch (error) {
//       console.error(error);
//       setErrorPopup(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Layout style={{ minHeight: "100vh" }}>
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}
//         collapsedWidth="0"
//         role="admin"
//       />

//       <Layout
//         className="main-layout"
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 40 : 210,
//           transition: "0.3s",
//           padding: isMobile ? 10 : 20,
//         }}
//       >
//         <Header className="MainHeader">
//           {isMobile && (
//             <Button
//               type="text"
//               icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }}
//             />
//           )}
//           <div style={{ flex: 1 }}>
//             <AntText style={{ fontSize: 20, fontWeight: "bold" }}>
//               Create Make Variation
//             </AntText>
//           </div>
//         </Header>

//         <Content style={{ padding: 20 }}>
//           <Card
//             title="Create New Variation"
//             bordered={false}
//             style={{ maxWidth: 700, margin: "0 auto" }}
//           >
//             <Form
//               form={form}
//               layout="vertical"
//               onFinish={handleSubmit}
//               autoComplete="off"
//             >
//               {/* STEP 1 — Select or create Category (variationType) */}
//               <Form.Item
//                 label="Step 1 — Select Category (Variation Type)"
//                 name="variationType"
//                 rules={[{ required: true, message: "Please select a category" }]}
//                 extra={
//                   <span style={{ color: "#888", fontSize: 12 }}>
//                     e.g. Hand variations, variations on legs, other variations
//                   </span>
//                 }
//               >
//                 <Select
//                   placeholder="— Select category —"
//                   showSearch
//                   allowClear
//                   onChange={handleCategoryChange}
//                   dropdownRender={(menu) => (
//                     <>
//                       {menu}
//                       <Divider style={{ margin: "8px 0" }} />
//                       <div style={{ padding: "0 8px 8px" }}>
//                         <p style={{ marginBottom: 6, color: "#555", fontSize: 13 }}>
//                           ➕ Create new category:
//                         </p>
//                         <Space.Compact style={{ width: "100%" }}>
//                           <Input
//                             placeholder="e.g. Shoulder variations"
//                             value={newCategoryInput}
//                             onChange={(e) => setNewCategoryInput(e.target.value)}
//                             onKeyDown={(e) => {
//                               if (e.key === "Enter") {
//                                 e.preventDefault();
//                                 handleAddCategory();
//                               }
//                             }}
//                           />
//                           <Button
//                             type="primary"
//                             icon={<PlusOutlined />}
//                             onClick={handleAddCategory}
//                           >
//                             Add
//                           </Button>
//                         </Space.Compact>
//                       </div>
//                     </>
//                   )}
//                 >
//                   {categories.map((cat) => (
//                     <Option key={cat} value={cat}>
//                       {cat}
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>

//               {/* STEP 2 — Select or create Pose (asanaType) */}
//               <Form.Item
//                 label="Step 2 — Select Pose (Asana Type)"
//                 name="asanaType"
//                 rules={[{ required: true, message: "Please select a pose" }]}
//                 extra={
//                   <span style={{ color: "#888", fontSize: 12 }}>
//                     Select existing pose to add content into it, or create new
//                   </span>
//                 }
//               >
//                 <Select
//                   placeholder="— Select pose —"
//                   showSearch
//                   allowClear
//                   onChange={handlePoseChange}
//                   dropdownRender={(menu) => (
//                     <>
//                       {menu}
//                       <Divider style={{ margin: "8px 0" }} />
//                       <div style={{ padding: "0 8px 8px" }}>
//                         <p style={{ marginBottom: 6, color: "#555", fontSize: 13 }}>
//                           ➕ Create new pose:
//                         </p>
//                         <Space.Compact style={{ width: "100%" }}>
//                           <Input
//                             placeholder="e.g. Namaskar"
//                             value={newPoseInput}
//                             onChange={(e) => setNewPoseInput(e.target.value)}
//                             onKeyDown={(e) => {
//                               if (e.key === "Enter") {
//                                 e.preventDefault();
//                                 handleAddPose();
//                               }
//                             }}
//                           />
//                           <Button
//                             type="primary"
//                             icon={<PlusOutlined />}
//                             onClick={handleAddPose}
//                           >
//                             Add
//                           </Button>
//                         </Space.Compact>
//                       </div>
//                     </>
//                   )}
//                 >
//                   {filteredPoses.map((pose) => (
//                     <Option key={pose} value={pose}>
//                       {pose}
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>

//               {/* STEP 3 — Variation details */}
//               <Form.Item
//                 label="Variation Name"
//                 name="variationName"
//                 rules={[{ required: true, message: "Variation name is required" }]}
//                 extra={
//                   <span style={{ color: "#888", fontSize: 12 }}>
//                     Auto-filled from pose selection — change if needed
//                   </span>
//                 }
//               >
//                 <Input placeholder="e.g. Namaskar" />
//               </Form.Item>

//               <Form.Item
//                 label="Sanskrit Name"
//                 name="sanskrit"
//                 rules={[{ required: true, message: "Sanskrit name is required" }]}
//               >
//                 <Input placeholder="e.g. Namaskar" />
//               </Form.Item>

//               <Form.Item
//                 label="Example Asana"
//                 name="exampleAsana"
//                 rules={[{ required: true, message: "Example asana is required" }]}
//               >
//                 <Input placeholder="e.g. Padmasana Namaskar" />
//               </Form.Item>

//               <Form.Item
//                 label="English Description"
//                 name="english"
//                 rules={[{ required: true, message: "English description required" }]}
//               >
//                 <Input.TextArea
//                   rows={4}
//                   placeholder="Describe the variation in English..."
//                 />
//               </Form.Item>

//               {/* Image Upload */}
//               <Form.Item label="Upload Variation Image">
//                 <Upload
//                   beforeUpload={(file) => {
//                     setSelectedImage(file);
//                     const reader = new FileReader();
//                     reader.onload = (e) => setImagePreview(e.target.result);
//                     reader.readAsDataURL(file);
//                     return false;
//                   }}
//                   maxCount={1}
//                 >
//                   <Button icon={<UploadOutlined />}>Select Image</Button>
//                 </Upload>

//                 {imagePreview && (
//                   <Image
//                     src={imagePreview}
//                     width={200}
//                     style={{ marginTop: 15, borderRadius: 10 }}
//                   />
//                 )}
//               </Form.Item>

//               <Form.Item>
//                 <Button
//                   type="primary"
//                   htmlType="submit"
//                   loading={loading}
//                   disabled={loading}
//                   size="large"
//                   style={{ width: "100%" }}
//                 >
//                   {loading ? "Creating..." : "Create Variation"}
//                 </Button>
//               </Form.Item>

//               <SuccessPopup
//                 open={successPopup}
//                 onClose={() => setSuccessPopup(false)}
//                 message={successMessage}
//               />
//               <ErrorPopup
//                 open={errorPopup}
//                 onClose={() => setErrorPopup(false)}
//                 message="Upload failed. Try again."
//               />
//             </Form>
//           </Card>
//         </Content>
//       </Layout>
//     </Layout>
//   );
// };

// export default MakeVariation;

import React, { useEffect, useState } from "react";
import {
  Layout,
  Card,
  Form,
  Input,
  Upload,
  Button,
  Select,
  message,
  Image,
  Typography,
  Divider,
  Space,
} from "antd";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../../Config/index";
import Sidebar from "../../Components/Sidebar";
import SuccessPopup from "../../Components/popup/SuccessPopup";
import ErrorPopup from "../../Components/popup/ErrorPopup";
import { MenuOutlined } from "@ant-design/icons";

const { Header, Content } = Layout;
const { Option } = Select;
const { Text: AntText } = Typography;

const MakeVariation = () => {
  const [form] = Form.useForm();

  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  // Level 1: Categories (variationType) loaded from DB
  const [categories, setCategories] = useState([]);
  const [newCategoryInput, setNewCategoryInput] = useState("");

  // Level 2: Poses (asanaType) filtered by selected category
  const [allData, setAllData] = useState([]);
  const [filteredPoses, setFilteredPoses] = useState([]);
  const [newPoseInput, setNewPoseInput] = useState("");

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/makevariations/names`);
      const data = res.data.data || [];
      setAllData(data);

      // Extract unique categories (variationType values)
      const cats = [];
      data.forEach((item) => {
        const type = item.variationType?.[0];
        if (type && !cats.includes(type)) cats.push(type);
      });
      setCategories(cats);
    } catch (err) {
      console.error("Failed to load data", err);
    }
  };

  // When category selected → filter poses belonging to it
  const handleCategoryChange = (selectedCategory) => {
    form.setFieldsValue({ asanaType: undefined });
    setFilteredPoses([]);

    if (!selectedCategory) return;

    const poses = [];
    allData.forEach((item) => {
      const type = item.variationType?.[0];
      if (
        type === selectedCategory &&
        item.asanaType &&
        !poses.includes(item.asanaType)
      ) {
        poses.push(item.asanaType);
      }
    });
    setFilteredPoses(poses);
  };

  // ✅ FIX: Pose selection no longer auto-fills variationName
  // User must type their own variation name manually
  const handlePoseChange = (selectedPose) => {
    // Pose selected — variationName stays empty for user to fill
  };

  // Add new category inline
  const handleAddCategory = () => {
    const trimmed = newCategoryInput.trim();
    if (!trimmed) return;
    if (categories.includes(trimmed)) {
      message.warning("Category already exists — select it from the list");
      setNewCategoryInput("");
      return;
    }
    setCategories((prev) => [...prev, trimmed]);
    form.setFieldsValue({ variationType: trimmed, asanaType: undefined });
    setFilteredPoses([]);
    setNewCategoryInput("");
    message.success(`New category "${trimmed}" added and selected`);
  };

  // Add new pose inline
  const handleAddPose = () => {
    const trimmed = newPoseInput.trim();
    if (!trimmed) return;
    if (filteredPoses.includes(trimmed)) {
      message.warning("Pose already exists — select it from the list");
      setNewPoseInput("");
      return;
    }
    setFilteredPoses((prev) => [...prev, trimmed]);
    // ✅ FIX: Only set asanaType — do NOT auto-fill variationName
    form.setFieldsValue({ asanaType: trimmed });
    setNewPoseInput("");
    message.success(`New pose "${trimmed}" added and selected`);
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    const formData = new FormData();
    formData.append("variationName", values.variationName);
    formData.append("sanskrit", values.sanskrit);
    formData.append("exampleAsana", values.exampleAsana);
    formData.append("english", values.english);
    formData.append("variationType", values.variationType);
    formData.append("asanaType", values.asanaType);

    if (selectedImage) {
      formData.append("variationImage", selectedImage);
    }

    try {
      const res = await axios.post(`${BASE_URL}/makevariations`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // ✅ FIX: No alreadyExists check — always treat success as a new creation
      if (res.data.success) {
        setSuccessMessage("Variation uploaded successfully!");
        setSuccessPopup(true);
        form.resetFields();
        setImagePreview(null);
        setSelectedImage(null);
        setFilteredPoses([]);
        fetchAllData();
      } else {
        message.error(res.data.message || "Failed to create variation");
      }
    } catch (error) {
      console.error(error);
      setErrorPopup(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />

      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 40 : 210,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >
        <Header className="MainHeader">
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <div style={{ flex: 1 }}>
            <AntText style={{ fontSize: 20, fontWeight: "bold" }}>
              Create Make Variation
            </AntText>
          </div>
        </Header>

        <Content style={{ padding: 20 }}>
          <Card
            title="Create New Variation"
            bordered={false}
            style={{ maxWidth: 700, margin: "0 auto" }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              autoComplete="off"
            >
              {/* STEP 1 — Select or create Category (variationType) */}
              <Form.Item
                label="Step 1 — Select Category (Variation Type)"
                name="variationType"
                rules={[{ required: true, message: "Please select a category" }]}
                extra={
                  <span style={{ color: "#888", fontSize: 12 }}>
                    e.g. Hand variations, variations on legs, other variations
                  </span>
                }
              >
                <Select
                  placeholder="— Select category —"
                  showSearch
                  allowClear
                  onChange={handleCategoryChange}
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider style={{ margin: "8px 0" }} />
                      <div style={{ padding: "0 8px 8px" }}>
                        <p style={{ marginBottom: 6, color: "#555", fontSize: 13 }}>
                          ➕ Create new category:
                        </p>
                        <Space.Compact style={{ width: "100%" }}>
                          <Input
                            placeholder="e.g. Shoulder variations"
                            value={newCategoryInput}
                            onChange={(e) => setNewCategoryInput(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleAddCategory();
                              }
                            }}
                          />
                          <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={handleAddCategory}
                          >
                            Add
                          </Button>
                        </Space.Compact>
                      </div>
                    </>
                  )}
                >
                  {categories.map((cat) => (
                    <Option key={cat} value={cat}>
                      {cat}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {/* STEP 2 — Select or create Pose (asanaType) */}
              <Form.Item
                label="Step 2 — Select Pose (Asana Type)"
                name="asanaType"
                rules={[{ required: true, message: "Please select a pose" }]}
                extra={
                  <span style={{ color: "#888", fontSize: 12 }}>
                    Select existing pose to add content into it, or create new
                  </span>
                }
              >
                <Select
                  placeholder="— Select pose —"
                  showSearch
                  allowClear
                  onChange={handlePoseChange}
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider style={{ margin: "8px 0" }} />
                      <div style={{ padding: "0 8px 8px" }}>
                        <p style={{ marginBottom: 6, color: "#555", fontSize: 13 }}>
                          ➕ Create new pose:
                        </p>
                        <Space.Compact style={{ width: "100%" }}>
                          <Input
                            placeholder="e.g. Namaskar"
                            value={newPoseInput}
                            onChange={(e) => setNewPoseInput(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleAddPose();
                              }
                            }}
                          />
                          <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={handleAddPose}
                          >
                            Add
                          </Button>
                        </Space.Compact>
                      </div>
                    </>
                  )}
                >
                  {filteredPoses.map((pose) => (
                    <Option key={pose} value={pose}>
                      {pose}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {/* STEP 3 — Variation Name (user types manually) */}
              <Form.Item
                label="Variation Name"
                name="variationName"
                rules={[{ required: true, message: "Variation name is required" }]}
                extra={
                  <span style={{ color: "#888", fontSize: 12 }}>
                    Enter a unique name for this specific variation (same name allowed multiple times)
                  </span>
                }
              >
                <Input placeholder="e.g. Reverse Namaskar" />
              </Form.Item>

              <Form.Item
                label="Sanskrit Name"
                name="sanskrit"
                rules={[{ required: true, message: "Sanskrit name is required" }]}
              >
                <Input placeholder="e.g. Namaskar" />
              </Form.Item>

              <Form.Item
                label="Example Asana"
                name="exampleAsana"
                rules={[{ required: true, message: "Example asana is required" }]}
              >
                <Input placeholder="e.g. Padmasana Namaskar" />
              </Form.Item>

              <Form.Item
                label="English Description"
                name="english"
                rules={[{ required: true, message: "English description required" }]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Describe the variation in English..."
                />
              </Form.Item>

              {/* Image Upload */}
              <Form.Item label="Upload Variation Image">
                <Upload
                  beforeUpload={(file) => {
                    setSelectedImage(file);
                    const reader = new FileReader();
                    reader.onload = (e) => setImagePreview(e.target.result);
                    reader.readAsDataURL(file);
                    return false;
                  }}
                  maxCount={1}
                >
                  <Button icon={<UploadOutlined />}>Select Image</Button>
                </Upload>

                {imagePreview && (
                  <Image
                    src={imagePreview}
                    width={200}
                    style={{ marginTop: 15, borderRadius: 10 }}
                  />
                )}
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  disabled={loading}
                  size="large"
                  style={{ width: "100%" }}
                >
                  {loading ? "Creating..." : "Create Variation"}
                </Button>
              </Form.Item>

              <SuccessPopup
                open={successPopup}
                onClose={() => setSuccessPopup(false)}
                message={successMessage}
              />
              <ErrorPopup
                open={errorPopup}
                onClose={() => setErrorPopup(false)}
                message="Upload failed. Try again."
              />
            </Form>
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MakeVariation;